/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

var Viewport = { };

Viewport.documentWidth = function() {
	var e = window, a = 'inner';

	if( !( 'innerWidth' in window ) ) {
		a = 'client';
		e = document.documentElement || document.body;
	}

	return { width: e[ a + 'Width' ], height: e[ a + 'Height' ] };
};

( function( $ ) {
	var Submission = { };

	Submission.success = function() {
		var successMessage = $( '.newsletter-form .section-title' );
		if( successMessage.length === 1 ) {
			$( 'html, body' ).animate( {
				scrollTop: $( '.s-form' ).offset().top
			} );
		}
	};

	var VideoEmbed = { };

	VideoEmbed.appendDiv = function() {
		var videoElement = $( '.single #single-post p iframe' );
		videoElement.each( function() {
			$( this ).removeAttr( 'width' );
			$( this ).removeAttr( 'height' );
			$( this ).wrap( "<div class='embed-container'></div>" );
		} );
	};

	var moveDivBtn = {};

	moveDivBtn.btns = function() {
		if (Viewport.documentWidth().width <= 991) {
	  		var dtmove = $('#move-this').html();
		  	if( $('#btn-destination').is(':empty') ) {
				$('#btn-destination').html( dtmove );
				$('#move-this').html('');
			}
	  	} else {
	  		var dtDest = $('#btn-destination').html();
	   		if( $('#move-this').is(':empty') ) {
				$('#move-this').html( dtDest );
				$('#btn-destination').html('');
			}
	 	}

	};


	var Modal = {};

	Modal.getVideoUrl = function() {
		var src = $( '#IntroVideo' ).find( 'iframe' ).attr( 'src' ) + '&autoPlay=true';

		$( '#IntroVideo' ).on( 'show.bs.modal', function() {
			$( this ).find( 'iframe' ).attr( 'src', src );
		} ).on( 'hide.bs.modal', function() {
			$( this ).find( 'iframe' ).attr( 'src', '' );
		} );
	};

	Modal.triggerClose = function() {
		$( '.modal-inner' ).mouseup( function ( e ) {
			var container = $( '.modal-content' );

			if ( e.which === 1 && !container.is( e.target ) && container.has( e.target ).length === 0 ) {
				$( '.modal' ).modal( 'hide' );
				$( '.mktoForm' ).show();
				$( '.reg-message' ).show();
				$( '.thank-you-message' ).hide();
			}
		} );
		$( '.close' ).mouseup( function () {
			$( '.modal' ).modal( 'hide' );
			$( '.mktoForm' ).show();
			$( '.reg-message' ).show();
			$( '.thank-you-message' ).hide();
		} );
	};

	Modal.connectMarketo = function() {
		$('#MarketoModal').on('show.bs.modal', function (event) {
			var button = $(event.relatedTarget),
			title = button.data('title'),
			paragraph = button.data('paragraph'),
			type = button.data('type'),
			modal = $(this);

			modal.find('.reg-title').html(title);
			modal.find('.reg-paragraph').html(paragraph);
			modal.find('.mktoField[name="pSEducationType"]').val(type);
		});
	};

	Modal.connectHubspot = function() {
		$('#HubspotModal').on('show.bs.modal', function (event) {
			var button = $(event.relatedTarget),
			title = button.data('title'),
			paragraph = button.data('paragraph'),
			type = button.data('type'),
			modal = $(this);

			modal.find('.reg-title').html(title);
			modal.find('.reg-paragraph').html(paragraph);
			modal.find('.hs-input[name="ps_education_type"]').val(type);
		});
	};

	// Use this variable to set up the common and page specific functions. If you
	// rename this variable, you will also need to rename the namespace below.
	var Sage = {
		// All pages
		'common': {
			init: function() {
				// JavaScript to be fired on all pages
				Submission.success();
				VideoEmbed.appendDiv();
				moveDivBtn.btns();
				Modal.getVideoUrl();
				Modal.triggerClose();
				Modal.connectMarketo();
				Modal.connectHubspot();
				// move element


				$( "#trigger_exam" ).click(function(e) {
					e.preventDefault();
					$( "#final_exam" ).submit();
				});

				$(window).resize(function() {
				  	moveDivBtn.btns();
				});
			},
			finalize: function() {
				// JavaScript to be fired on all pages, after page specific JS is fired
			}
		},
		// Home page
		'home': {
			init: function() {
				// JavaScript to be fired on the home page
			},
			finalize: function() {
				// JavaScript to be fired on the home page, after the init JS
			}
		},
		// About us page, note the change from about-us to about_us.
		'about_us': {
			init: function() {
				// JavaScript to be fired on the about us page
			}
		}
	};

	// The routing fires all common scripts, followed by the page specific scripts.
	// Add additional events for more control over timing e.g. a finalize event
	var UTIL = {
		fire: function( func, funcname, args ) {
			var fire;
			var namespace = Sage;
			funcname = ( funcname === undefined ) ? 'init' : funcname;
			fire = func !== '';
			fire = fire && namespace[func];
			fire = fire && typeof namespace[func][funcname] === 'function';

			if( fire ) {
				namespace[func][funcname]( args );
			}
		},
		loadEvents: function() {
			// Fire common init JS
			UTIL.fire( 'common' );

			// Fire page-specific init JS, and then finalize JS
			$.each( document.body.className.replace( /-/g, '_' ).split( /\s+/ ), function( i, classnm ) {
				UTIL.fire( classnm );
				UTIL.fire( classnm, 'finalize' );
			} );

			// Fire common finalize JS
			UTIL.fire( 'common', 'finalize' );
		}
	};

	// Load Events
	$( document ).ready( UTIL.loadEvents );

} )( jQuery ); // Fully reference jQuery after this point.
